import useClaimDialog from '@/components/dialogs/claims/useClaimDialog';
import { ConfirmationDialog } from '@/components/dialogs/generic/confirmation';

const VerwijderClaimDialog = ({ showDialog, handleOpenChange, details }) => {
  const { resetDialog, verwijderClaim } = useClaimDialog(details, handleOpenChange);

  return (
    <ConfirmationDialog
      hasCloseInHeader={true}
      handleOpenChange={handleOpenChange}
      showDialog={showDialog}
      onCancel={() => resetDialog(true)}
      onConfirm={() => verwijderClaim(details)}
      confirmButtonType='destructive'
      cancelText='Annuleren'
      confirmText='Verwijder claim'
      title='Verwijder Claim'
      message='Weet je zeker dat je deze claim wilt verwijderen? Dit kan niet teruggedraaid worden.'
    />
  );
};

export default VerwijderClaimDialog;
